import { Grid, GridItem, Skeleton, AspectRatio } from '@chakra-ui/react'
import type { ReactElement } from 'react'

const FolderGridLoader = (): ReactElement | null => (
  <Grid
    gridTemplateColumns={[
      'repeat(1, minmax(4px, 1fr))',
      'repeat(2, minmax(4px, 1fr))',
      'repeat(3, minmax(4px, 1fr))',
      'repeat(5, minmax(4px, 1fr))',
    ]}
    columnGap={6}
    rowGap={6}
    width="100%"
  >
    {Array.from({ length: 5 }).map((_, idx) => (
        <GridItem key={idx}>
          <Skeleton height="52px" weight="222px" borderRadius="0.5rem"/>
        </GridItem>
    ))}
  </Grid>
)

export default FolderGridLoader
